<div class="nb-phone-input">
  <div class="nb-phone-holder">
    <label class="label" :for="id">
      {{ label }}
    </label>
    <!-- Country Select -->
    <NBFormSelect
      :options="countries"
      class="country-select"
      valueKey="country_code"
      v-model="selectedCountry"
    >
      <template #selected="{ option }">
        <div class="option-with-flag">
          <img :src="option.icon" class="flag" :alt="option.name" />
          <span>{{ option.prefix }}</span>
        </div>
      </template>
      <template #option="{ option }">
        <div class="option-with-flag">
          <img :src="option.icon" class="flag" :alt="option.name" />
          <span>{{ option.prefix }}</span>
        </div>
      </template>
    </NBFormSelect>
    <!-- Phone Number -->
    <NBFormInput
      type="number"
      class="phone-input"
      v-model="localPhone"
      :labelId="id"
      autocomplete="tel-national"
      name="phone"
    />
  </div>
  <div v-if="error" class="error-message">
    {{ error }}
  </div>
</div>
